<template>
<div class="wrap">
    <div class="title">
        <h2 class="dp-inblock">1:1 문의</h2>
        <p class="w-100per">
            - 1:1 문의 내용 및 처리현황을 알 수 있습니다. <br>
            - 1:1 문의 내용은 수강신청 문의에 등록된 모든 HQ 매니저에게 메일로도 발송 됩니다.
        </p>
    </div>

    <div class="w-100per mg-auto">
        <table class="admin-table-top table-auto">
            <thead>
                <tr>
                    <th width="200px">이름</th>
                    <td width="*">
                        <input type="text" v-model="name" class="w-100per" placeholder="이름을 입력해 주세요">
                    </td>
                    <th class="w-200px">Company</th>
                    <td>
                        <input type="text" v-model="companyName" class="w-100per" placeholder="회사명을 입력해 주세요">
                    </td>
                </tr>
                <tr>
                    <th class="w-200px">E-mail</th>
                    <td colspan="3">
                        <input type="text" v-model="email" class="w-100per" placeholder="E-mail을 입력해 주세요">
                    </td>
                </tr>
            </thead>
        </table>
        <div class="mt-10 float-right dp-block"><button class="admin-btn-default w-70px" @click="search()">검색</button></div>
    </div>

    <div class="con w-100per mg-auto">
        <div class="state-box dp-inblock mt-50 w-100per">
            <span>HQ매니저 : </span>
            <select v-model="selectHqManager" @change="changeHQManager(selectHqManager)" name="" id="" class="w-150px ml-05 mr-05">
                <option value="-1">전체</option>
                <option v-for="(item, index) of hqManagers" :key="index" :value="item">{{item.name}}</option>
            </select>
            <span class="ml-10">처리자 : </span>
            <select v-model="selectManager" @change="changeManager(selectManager)" name="" id="" class="w-150px mr-05">
                <option value="-1">전체</option>
                <option v-for="(item, index) of hqManagers" :key="index" :value="item">{{item.name}}</option>
            </select>
            <select v-model="status" @change="search()" name="" id="" class="w-100px mr-05">
                <option value="">상태전체</option>
                <option value="X">미처리</option>
                <option value="N">처리 중</option>
                <option value="O">처리완료</option>
            </select>
        </div>

        <div class="mt-20">
            <table class="admin-table-col mt-10 txt-center">
                <thead>
                    <tr>
                        <th width="50px">No</th>
                        <th width="100px">등록일</th>
                        <th width="100px">Company</th>
                        <th width="100px">수강신청 명</th>
                        <th width="80px">이름</th>
                        <th width="100px">연락처</th>
                        <th width="100px">E-mail</th>
                        <th width="50px">상태</th>
                        <th width="120px">HQ매니저</th>
                        <th width="120px">처리자</th>
                        <th width="80px">등록일</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) of qaList" :key="index">
                        <td>{{listLength - (50 * (pageNum - 1)) - index}}</td>
                        <td>{{item.create_date.slice(0, 10)}}</td>
                        <td class="break-all">{{item.company_name_direct}}</td>
                        <td class="break-all">{{item.sugang_name}}</td>
                        <td class="pointer txt-blue break-all" @click="openModal(item.idx)" data-toggle="modal" data-target="#student_selet">{{item.name}}</td>
                        <td>{{item.mobile}}</td>
                        <td>{{item.email}}</td>
                        <td>
                            <span v-if="status === 'O'">{{formatQnAStatus(item.status)}}</span>
                            <span v-else class="pointer" @click="openModal(item.idx)" :class="{'txt-green': item.status === 'N', 'txt-red': item.status === 'X'}" data-toggle="modal" data-target="#student_selet">{{formatQnAStatus(item.status)}}</span>
                        </td>
                        <td>{{item.hq_name_mng}}</td>
                        <td>{{item.manager || '-'}}</td>
                        <td>{{item.create_date.slice(0, 10)}}</td>
                    </tr>

                    <!-- 리스트에 내용이 없을 경우 -->
                    <tr v-if="listLength === 0">
                        <td colspan="11" class="pt-10 pb-10">등록된 정보가 없습니다.</td>
                    </tr>

                </tbody>
            </table>

            <div class="paging mt-30">
                <ul>
                    <li>
                        <a class="pointer" @click="prevPaging()"> &lt; </a>
                    </li>
                    <li v-for="index in calcMaxPaging()" :key="index" class="txt-blue">
                        <span class="pointer" style="padding: 8px;">
                            <a @click="paging(index)" :class="{'carrot-active bold': index === pageNum}">{{index}}</a>
                        </span>
                    </li>
                    <li>
                        <a class="pointer" @click="nextPaging()"> &gt; </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <detail-modal v-if="isModalOpened" :parentQaIdx="parentQaIdx" @close="closeModal"></detail-modal>
</div>
</template>

<script>
import DetailModal from '@/components/qna/detailModal.vue'
export default {
    components: {
        DetailModal
    },

    data: () => ({
        companyName: '', // 회사명
        email: '', // 이메일
        hqIdx: '', // hq매니저 고유idx
        managerIdx: '-1', // 담당매니저 고유idx
        name: '', // 이름
        pageNum: 1, // 페이징 넘버
        pageSize: 50, // 페이지 크기
        status: '', // 상태전체 '' 미처리 X 처리중 N 처리완료 O

        maxPagingCount: 1, // 최대 페이지 수
        maxPagePart: 1, // 최대 파트가 몇번째인지
        pagePart: 1 , // 현재 페이징이 몇번째 파트에 있는지 (ex 1~10 1파트, 11~20 2파트)

        loginIdxItmSugangEmpMng: '', // 현재 로그인한 HQ매니저 idx
        hqManagers: [], // HQ매니저 전체 리스트 정보
        selectHqManager: {}, // 선택된 HQ 매니저 정보
        selectManager: '-1', // 선택된 담당 매니저 정보

        qaList: [], // 1:1 문의 리스트
        listLength: 0, // 리스트 총 갯수

        isModalOpened: false,
        parentQaIdx: '' // 상세 레이어팝업에 
    }),

    mounted() {
        this.loginIdxItmSugangEmpMng = localStorage.getItem('regid')
        this.hqIdx = this.loginIdxItmSugangEmpMng
        this.managerIdx = '-1'

        this.asyncSearch()
    },

    methods: {
        // QNA status에 따른 한글 변환
        formatQnAStatus(status) {
            switch (status) {
                case 'X':
                    return '미처리'
                case 'N':
                    return '처리중'
                case 'O':
                    return '처리완료'
                default:
                    return '-'
            }
        },

        // HQ Manager을 먼저 호출하고 1:1 리스트를 호출하기 위해 async함수 추가
        async asyncSearch() {
            await this.fetchHQList()
            await this.search()
        },

        // HQList api 호출
        async fetchHQList() {
            await this.axios.get(this.axios.root + this.axios.port + '/admin/list')
                .then(res => {
                    console.log('res', res)
                    if (res.data.err === 0) {
                        this.hqManagers = res.data.hqList
                        for (var manager of this.hqManagers) {
                            if (manager.regid === Number(this.loginIdxItmSugangEmpMng)) {
                                console.log('같은 아이디 찾음', manager)
                                this.idxItmSugangEmpMng = Number(this.loginIdxItmSugangEmpMng)
                                this.selectHqManager = manager
                                // this.selectManager = manager
                            }
                        }
                    } else if (res.data.err === 401) {
                        alert(res.data.result)
                        this.$router.push('/admin/login')
                        localStorage.clear()
                    }
                }).catch(err => {
                    alert('세션이 만료되어 로그인 창으로 이동합니다.')
                    this.$router.push('/admin/login')
                    console.log('err', err)
                })
        },

        // 페이징
        paging (page) {
            this.pageNum = page
            this.search()
        },

        // 이전 페이징
        prevPaging () {
            if (this.pageNum === 1) {
                return false
            } else {
                this.pageNum -= 1
                this.search()
            }
        },

        // 다음 페이징
        nextPaging () {
            if (this.pageNum === this.maxPagingCount) {
                return false
            } else {
                this.pageNum += 1
                this.search()
            }
        },

        // 현재 페이지의 페이지 범위 계산
        calcMaxPaging () {
            if (this.maxPagingCount > this.pagePart * 10) {
                this.maxPagePart = this.pagePart * 10
            } else {
                this.maxPagePart = this.maxPagingCount
            }
            var pagingArray = []
            for (var i = ((this.pagePart - 1) * 10) + 1; i <= this.maxPagePart; i++) {
                pagingArray.push(i)
            }
            return pagingArray
        },

        // HQ매니저 select 변경시 idx 같이 변경
        changeHQManager(data) {
            if (data !== '-1') {
                this.hqIdx = data.regid
            } else {
                this.hqIdx = -1
            }
            this.search()
        },

        // 담당매니저 select 변경시 idx 같이 변경
        changeManager(data) {
            if (data !== '-1') {
                this.managerIdx = data.regid
            } else {
                this.managerIdx = '-1'
            }
            this.search()
        },

        // 신청자 리스트 검색
        async search() {
            var params = {
                companyName: this.companyName,
                email: this.email,
                hqIdx: this.hqIdx,
                managerIdx: this.managerIdx,
                name: this.name,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                status: this.status
            }

            if (this.hqIdx === '') {
                delete param['hqIdx']
            }

            if (this.managerIdx === '') {
                delete param['hqIdx']
            }

            console.log('params', params)
            await this.axios.get(this.axios.root + this.axios.port + '/admin/qa-list', {
                params: params
            }).then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.qaList = res.data.qaList

                    if (res.data.qaListSize) {
                        this.listLength = res.data.qaListSize
                    }

                    this.maxPagingCount = Math.ceil(this.listLength / this.pageSize)
                    this.maxPagePart = Math.ceil(this.maxPagingCount / 10)
                    this.pagePart = Math.ceil(this.pageNum / 10)
                } else {
                    this.qaList = []
                    this.listLength = 0
                }
            })
        },

        // 검색 모달 열기
        openModal(qaIdx) {
            this.parentQaIdx = qaIdx
            this.isModalOpened = true
        },

        // 검색 모달 닫기
        closeModal() {
            this.search()
            this.isModalOpened = false
        }
    }
}
</script>
